// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmbeddedHeaderModal_wrapper__3Nbw0","container":"EmbeddedHeaderModal_container__26Jod","content":"EmbeddedHeaderModal_content__2LqAj"};